// Studyo Today Backend
// Package studyo.today.item_duplication.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/item_duplication/v1/resources/occurrence_item_repetition.proto (package studyo.today.item_duplication.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/item_duplication/v1/resources/occurrence_item_repetition.proto.
 */
export const file_studyo_today_item_duplication_v1_resources_occurrence_item_repetition = /*@__PURE__*/
  fileDesc("CktzdHVkeW8vdG9kYXkvaXRlbV9kdXBsaWNhdGlvbi92MS9yZXNvdXJjZXMvb2NjdXJyZW5jZV9pdGVtX3JlcGV0aXRpb24ucHJvdG8SKnN0dWR5by50b2RheS5pdGVtX2R1cGxpY2F0aW9uLnYxLnJlc291cmNlcyIaChhPY2N1cnJlbmNlSXRlbVJlcGV0aXRpb25CMaoCLlN0dWR5by5Ub2RheS5JdGVtRHVwbGljYXRpb24uR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the message studyo.today.item_duplication.v1.resources.OccurrenceItemRepetition.
 * Use `create(OccurrenceItemRepetitionSchema)` to create a new message.
 */
export const OccurrenceItemRepetitionSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_item_duplication_v1_resources_occurrence_item_repetition, 0);

